import { render, staticRenderFns } from "./ClientBulkImportView.vue?vue&type=template&id=7528c903&scoped=true"
import script from "./ClientBulkImportView.vue?vue&type=script&lang=ts"
export * from "./ClientBulkImportView.vue?vue&type=script&lang=ts"
import style0 from "./ClientBulkImportView.vue?vue&type=style&index=0&id=7528c903&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7528c903",
  null
  
)

export default component.exports